import { render } from "./ComponentQuickNote.vue?vue&type=template&id=8d16ba12&scoped=true"
import script from "./ComponentQuickNote.vue?vue&type=script&lang=js"
export * from "./ComponentQuickNote.vue?vue&type=script&lang=js"

import "./ComponentQuickNote.vue?vue&type=style&index=0&id=8d16ba12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d16ba12"]])

export default __exports__